<template>
    <div>
        <base-header class="header pb-8 pt-5 pt-lg-8 d-flex align-items-center no-padding-bottom">
            <span class="mask bg-gradient-danger opacity-8"></span>
        </base-header>

        <div class="container-fluid mt--7">
            <div class="row">
                <div class="col-xl-12 order-xl-1">
                    <br><br><br>
                    <card shadow type="secondary">
                        <div slot="header" class="bg-white border-0">
                            <div class="row align-items-center">

                                <div class="col-8">
                                    <h3 class="mb-0 text-uppercase">{{ this.$route.name }}</h3>
                                    <br>
                                    <span class="text-danger">
                                        Kindly select appropriate Assessment Category and proceed to either generate RRR for payment
                                        through designated banks or pay online now
                                    </span>
                                </div>
                                <div class="col-4 text-right">
                                    <a :href="websiteUrl" class="btn btn-sm btn-danger">
                                       <i class="fa fa-reply"></i> Home
                                    </a>
                                </div>
                            </div>
                        </div>

                        <div v-if="! showPaymentPage">
                            <div class="row" v-if='! isLoadingBlade && ! backError'>
                                <div class="col-lg-6">
                                    <base-input alternative=""
                                        label="Assessment Category"
                                        required
                                    >
                                        <select
                                            class="form-control form-control-alternative"
                                            v-model="category"
                                            @change="emptyFields"
                                        >
                                            <option :value="null" disabled selected>--- Select One ---</option>
                                            <option
                                                v-for="cat in categories"
                                                :key="cat.id"
                                                :value="cat.id"
                                            >
                                                {{ cat.title }}
                                                <em v-if="cat.description">({{ cat.description }})</em>
                                            </option>
                                        </select>
                                    </base-input>
                                </div>

                                <div class="col-lg-6" v-if="showCountry">
                                    <base-input alternative=""
                                        label="Country of Medical School (Dental Applicants Only)"
                                        required
                                    >
                                        <select
                                            class="form-control form-control-alternative"
                                            v-model="country"
                                        >
                                            <option :value="null" disabled selected>--- Select One ---</option>
                                            <option
                                                v-for="location in locations.countries"
                                                :key="location.id"
                                                :value="location"
                                            >
                                                {{ location.name }}
                                            </option>
                                        </select>
                                    </base-input>
                                </div>

                                <div class="col-lg-6">
                                    <base-input alternative=""
                                        label="Payee's Full Name"
                                        placeholder="Payee's Full Name"
                                        input-classes="form-control-alternative"
                                        v-model="record.name"
                                        required
                                    />
                                </div>

                                <div class="col-lg-6">
                                    <base-input alternative=""
                                        label="Payee's Email Address"
                                        placeholder="Payee's Email Address"
                                        input-classes="form-control-alternative"
                                        v-model="record.email"
                                        required
                                    />
                                </div>

                                <div class="col-lg-6">
                                    <base-input alternative=""
                                        label="Payee's Phone Number"
                                        placeholder="Payee's Phone Number"
                                        input-classes="form-control-alternative"
                                    >
                                    <!-- v-model="profile.phone"  -->
                                        <VuePhoneNumberInput
                                            v-model="tel"
                                            @update="updatePhoneNumber"
                                            default-country-code="NG"
                                            :no-example="true"
                                            :clearable="true"
                                        />
                                    </base-input>
                                </div>

                            </div>

                            <div class="col-lg-12" v-if="isLoadingBlade">
                                <div class="d-flex justify-content-center">
                                    <img :src="loadingBladeUrl" />
                                </div>
                            </div>

                            <div class="col-lg-12 text-center" v-if='showErrorStatus && ! isLoadingBlade'>
                                <base-alert :type="errorType">
                                    <!-- <span class="alert-inner--icon"><i class="ni ni-like-2"></i></span> -->
                                    <span class="alert-inner--text">
                                        <h2 class="text-white">{{errorMsg}}</h2>
                                    </span>
                                </base-alert>
                            </div>
                        </div>

                        <!-- this country is null now (today 28-4-2205 requested by Mrs Ruth) because the postage fee for dental applicants should 
                        no longer be added  -->

                        <!-- :country="country" -->
                        <AssessmentPaymentData
                            :type="type"
                            :record="record"
                            :serviceType="serviceType"
                            :country="null"
                            v-on:goBack="goBack"
                            v-if="showPaymentPage"
                        />

                        <div v-if="! showErrorStatus && ! showPaymentPage">
                            <hr>
                            <router-link
                                to="/assessment-exam"
                                class="btn btn-danger"
                                :disabled="isLoadingBlade"
                            >
                                <i class="fa fa-arrow-left"></i>
                                Go Back
                            </router-link>

                            <base-button
                                type="success"
                                class="right"
                                :disabled="isLoadingBlade"
                                @click="getPayments()"
                            >
                                {{ isLoadingBlade ? 'Please Wait...' : 'Proceed Now'}}
                                <i class="fa fa-arrow-right"></i>
                            </base-button>
                            <br><br><br><br>
                        </div>

                    </card>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapActions, mapGetters } from 'vuex';
    import AssessmentPaymentData from './AssessmentPaymentData';
    import VuePhoneNumberInput from 'vue-phone-number-input';
    import 'vue-phone-number-input/dist/vue-phone-number-input.css';
    import swal from 'sweetalert2';// import sweet alert

    export default {
        name: 'AssessmentGenerate',
        components: {
            AssessmentPaymentData,
            VuePhoneNumberInput
        },
        data() {
            return {
                isLoadingBlade: true,
                batch: null,
                record: {
                    name: null,
                    email: null,
                    phone: null
                },
                tel: null,
                category: null,
                country: null,
                showErrorStatus: false,
                errorType: null,
                errorMsg: null,
                categories: [],
                type: null,
                serviceType: null,
                showPaymentPage: false,
                backError: false
            }
        },
        computed: {
            ...mapGetters(['websiteUrl', 'loadingBladeUrl', 'locations']),
            showCountry() {// for dental only
                return (this.category == 2) || (this.category == 4);
            }
        },
        methods: {
            ...mapActions(['getAssessmentTypes', 'getAssessmentBatch', 'getAssessmentPayment', 'getLocations']),
            updatePhoneNumber(event) {
                if(event && event.isValid && event.e164) {
                    this.record.phone = event.formattedNumber;
                }
            },
            goBack() {
                this.emptyFields();
                this.tel = null;
                this.category = null;
                this.showPaymentPage = false;
                this.loadAssessmentBatch();
            },
            loadAssessmentBatch() {
                localStorage.removeItem('applicantId');
                this.emptyFields();
                this.backError = false;
                this.showPaymentPage = false;
                this.getAssessmentBatch().then((res) => {
                    this.getLocations();// get locations
                    this.isLoadingBlade = false;
                    if(res.status) {
                        this.batch = res.batch;
                        this.serviceType = res.service_type;
                        this.showErrorStatus = false;
                        this.loadAssessmentTypes();
                    } else {
                        this.backError = true;
                        this.showErrorStatus = true;
                        this.errorMsg = res.msg;
                        this.errorType = 'danger';
                    }
                }).
                catch(() => {
                    this.backError = true;
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Network Failure!, kindly reload the page...";
                    this.errorType = 'danger';
                });
            },
            loadAssessmentTypes() {
                this.isLoadingBlade = true;
                this.categories = [];
                let data = { 'type' : true };
                this.getAssessmentTypes(data).then((res) => {
                    this.categories = res.types;
                    this.showErrorStatus = false;
                    this.isLoadingBlade = false;
                }).
                catch(() => {
                    this.showErrorStatus = true;
                    this.isLoadingBlade = false;
                    this.errorMsg = "Network Failure!, kindly reload the page...";
                    this.errorType = 'danger';
                });
            },
            getPayments() {
                this.isloading = true;
                this.preloader();// show loading
                let status = this.validatedData();// valid input data
                if(status && this.batch) {// update
                    let data = { id : this.batch.id, typeId : this.category };
                    this.getAssessmentPayment(data).then((res) => {
                        this.isloading = false;
                        if(res.status) {
                            this.type = res.type;
                            this.showPaymentPage = true;
                            swal.close()
                        } else {
                            let msg = "Payment details could not be found, reload page";
                            swal.fire("Error Ocurred!", msg, "warning");
                        }
                    }).
                    catch(() => {
                        this.isloading = false;
                        let msg = "Network Failure!, kindly reload the page...";
                        swal.fire("Error Ocurred!", msg, "warning");
                    });
                }   else {
                    this.isloading = false;
                    swal.close();
                }
            },
            emptyFields() {
                this.record = {
                    name: null,
                    email: null,
                    phone: null
                };
                this.country = null;
            },
            validatedData() {
                let data = this.record;
                data.phone != null ? data.phone : this.showInuptError('Payees\'s Phone Number');
                data.email != null ? data.email : this.showInuptError('Payees\'s Email Address');
                data.name != null ? data.name : this.showInuptError('Payees\'s Full Name');
                (this.showCountry && this.country != null) || ! this.showCountry
                                ? this.country : this.showInuptError('Country of Medical School');
                this.category != null ? this.category : this.showInuptError('Assessment Category');
                let status = (data.name && data.email && data.phone && this.category) &&
                            ((this.showCountry && this.country) || ! this.showCountry);
                return status ? true : false;
            },
            showInuptError(name) {
                this.isloading = false;
                this.showErrorStatus = true
                this.errorType = 'warning'
                this.errorMsg = 'Invalid ' + name + ' has been entered';
                var self = this;
                setTimeout(function() { self.showErrorStatus = false; }, 5000);
            },
            preloader() {
                return  swal.fire({
                    title: 'Please Wait...',
                    html: 'Trying to fetch data from <b>server</b>',
                    // timer: 2000,
                    timerProgressBar: true,
                    onBeforeOpen: () => {
                        swal.showLoading()
                    },
                });
            }
        },
        created() {
            this.loadAssessmentBatch();
        }
    }
</script>

<style scoped>
    .no-padding-bottom {
        padding-bottom: 0rem !important
    }
    .right {
        float: right;
    }
</style>

<style>
    .form-control-label {
        width: 100%;
    }
    .height-50 {
        height: 50px;
    }
    .borderLine {
        border: 1px solid #ededed;
    }
</style>